import { Stack, TextInput } from '@mantine/core';
import type { ImportConfig } from '@repo/api-codegen';
import { Banner, Text } from '@repo/foundations';
import { IntegrationSelector } from '../../../components/EntityModal/Metadata/IntegrationSelector';

interface SourceConfigurationProps {
	onValidate: (credentials: ImportConfig) => void;
	isLoading: boolean;
	apiKey: string;
	sourceId: string;
	integrationId: string;
	onApiKeyChange: (value: string) => void;
	onSourceIdChange: (value: string) => void;
	onIntegrationChange: (value: string) => void;
	errorMessage: string | null;
}

export function SourceConfiguration({
	onValidate,
	isLoading,
	apiKey,
	sourceId,
	integrationId,
	onApiKeyChange,
	onSourceIdChange,
	onIntegrationChange,
	errorMessage,
}: SourceConfigurationProps) {
	return (
		<Stack spacing="md">
			<Text size="lg" weight="semibold">
				Configure Metaplane Connection
			</Text>

			<TextInput
				label="Metaplane API Key"
				placeholder="Enter your Metaplane API key"
				value={apiKey}
				onChange={(event) => onApiKeyChange(event.currentTarget.value)}
				required
			/>

			<TextInput
				label="Source ID"
				placeholder="Enter the source ID"
				value={sourceId}
				onChange={(event) => onSourceIdChange(event.currentTarget.value)}
				required
			/>

			<Stack spacing="xs">
				<Text size="sm" weight="semibold">
					Integration
				</Text>
				<IntegrationSelector
					onChange={onIntegrationChange}
					initialValue={integrationId}
				/>
				<Text size="xs" color="text/secondary/default">
					This ensures monitors are connected to the right data source in Secoda
				</Text>
			</Stack>

			{errorMessage && (
				<Banner tone="critical" title="Import Error" message={errorMessage} />
			)}
		</Stack>
	);
}
